import { MDBAlert, MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from "react"
import Select from 'react-select'
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Label, Media, Row } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"

const columns = [
    {
        label: "Código",
        field: "articulo_codigo",
        sort: "asc",
    },
    {
        label: "Nombre",
        field: "articulo_nombre",
        sort: "asc",
        width: 150,
    },
    {
        label: "Descripción",
        field: "articulo_descripcion",
        sort: "asc",
        width: 150,
    },
    {
        label: "Serie",
        field: "articulo_serie",
        sort: "asc",
        width: 150,
    },
    /*{
        label: "Costo",
        field: "articulo_costo",
        sort: "asc",
        width: 150,
    },*/
    {
        label: "Cantidad",
        field: "cantidad",
        sort: "asc",
        width: 150,
    },
    /*{
        label: "Monto Total",
        field: "monto_total",
        sort: "asc",
        width: 150,
    },*/
    {
        label: "Departamento/Area",
        field: "departamento_area_nombre",
        sort: "asc",
        width: 150,
    },
    {
        label: "Ubicación Fisica",
        field: "area_trabajo_nombre",
        sort: "asc",
        width: 150,
    },
    {
        label: "Estado",
        field: "estado",
        sort: "asc",
        width: 150,
    },
    {
        label: "Acciones",
        field: "handle",
        width: 100
    }
];

export default class TajetaResponsabilidadFormulario extends React.Component {
    
    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                nombre: ''
            },
            tabla: { columns: columns, rows: [] },
            colapsar: true,
            modalAsignarArticulo: false,
            modalDesasignarArticulo: false,
            modalActualizarArticulo: false,
            articuloAsignar: {},
            articuloActualizar: {},
            articuloDesasignar: {},
            departamentoAreaSelectValue: null,
            areaTrabajoSelectValue: null,
            articuloSelectValue: null,
            razonSelectValue: null,
            cantidadNoAsignada: 0,
            articulos: [],
            departamentosAreas: [],
            areasTrabajo: [],
            camposRequeridos: [],
            errors:{}
        };
    }

    componentDidMount() {
        this.cargarListado();
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    cargarListado = () => {
        this.setState( { mostrarSpinner: true });
        this.apiRest.get('/tarjetaResponsabilidadArticulos/' + this.state.registro.id).then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({  mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data) });
            }
        });
    }

    botonesListado = registro => [
        <MDBBtn className="waves-effect"size="sm" color="primary" title="Actualizar" onClick={() => this.mostrarModalActualizarArticulo(registro)}>
            <MDBIcon icon="far fa-edit" />
        </MDBBtn>
        , ' ',
        <MDBBtn className="waves-effect"size="sm" color="danger" title="Desasignar" onClick={() => this.mostrarModalDesasignarArticulo(registro)}>
            <MDBIcon icon="fas fa-times" />
        </MDBBtn>
    ];

    agregarAccionesRegistro = rows => {
        rows.forEach(registro => registro.handle = this.botonesListado(registro));
        return { columns, rows: rows };
    };

    enviarCorreo = () => {
        this.apiRest.get('/tarjetaResponsabilidadEnviarCorreo/' + this.state.registro.id).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Correo enviado exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    mostrarModalAsignarArticulo = () => {
        this.obtenerArticulos();
        this.obtenerDepartamentosAreas();
        this.obtenerAreasTrabajo();

        this.setState({ modalAsignarArticulo: true, articuloAsignar: {}, areaTrabajoSelectValue: null });
    }
    ocultarModalAsignarArticulo = () => {
        this.setState({ modalAsignarArticulo: false });
    }

    mostrarModalActualizarArticulo = articuloAsignado => {
        this.obtenerAreasTrabajo();
        this.obtenerDepartamentosAreasActualizar();
        this.setState(estadoAnterior => ({
            articuloAsignar: { ...estadoAnterior.articuloAsignar, ['id']: articuloAsignado.id }
        }));
        this.setState(estadoAnterior => ({
            articuloAsignar: { ...estadoAnterior.articuloAsignar, ['idDepartamentoArea']: articuloAsignado.id_departamento }
        }));

        this.state.areaTrabajoSelectValue = articuloAsignado.area_trabajo;
        this.state.articuloAsignar.cantidad = articuloAsignado.cantidad;
        this.setState({ modalActualizarArticulo: true });
    }
    ocultarModalActualizarArticulo = () => {
        this.setState({ modalActualizarArticulo: false });
    }

    mostrarModalDesasignarArticulo = articuloAsignado => {
        this.setState(estadoAnterior => ({
            articuloDesasignar: { ...estadoAnterior.articuloDesasignar, ['id']: articuloAsignado.id }
        }));

        this.state.articuloDesasignar.cantidad = articuloAsignado.cantidad;
        this.setState({ modalDesasignarArticulo: true });
    }
    ocultarModalDesasignarArticulo = () => {
        this.setState({ modalDesasignarArticulo: false });
    }

    asignarArticulo = () => {

        let articuloAsignar = this.state.articuloAsignar;
        articuloAsignar.crearTarjetaResponsabilidad = false;
        articuloAsignar.idTarjetaResponsabilidad = this.state.registro.id;

        this.apiRest.post('/tarjetaResponsabilidadAsignarArticulo', articuloAsignar).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Datos almacenados exitosamente!');
                this.ocultarModalAsignarArticulo();
                this.cargarListado();
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    actualizarArticulo = () => {
        let articuloAsignar = this.state.articuloAsignar;
        articuloAsignar.crearTarjetaResponsabilidad = false;
        articuloAsignar.idTarjetaResponsabilidad = this.state.registro.id;
        articuloAsignar.idAreaTrabajo = this.state.areaTrabajoSelectValue.id

        this.apiRest.put('/tarjetaResponsabilidadAsignarArticulo', articuloAsignar).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Datos almacenados exitosamente!');
                this.ocultarModalActualizarArticulo();
                this.cargarListado();
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    desasignarArticulo = () => {
        let articuloDesasignar = this.state.articuloDesasignar;
        articuloDesasignar.idTarjetaResponsabilidad = this.state.registro.id;

        this.apiRest.post('/tarjetaResponsabilidadDesasignarArticulo', articuloDesasignar).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Datos almacenados exitosamente!');
                this.ocultarModalDesasignarArticulo();
                this.cargarListado();
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    setArticulo = articulo => {
        this.setState(estadoAnterior => ({
            articuloAsignar: { ...estadoAnterior.articuloAsignar, ['idArticulo']: articulo.id },
            articuloSelectValue: articulo
        }));

        this.apiRest.get('/articuloCantidadNoAsignada/' + articulo.id).then(resultado => {
            if (resultado.exitoso) {
                this.setState(estadoAnterior => ({
                    articuloAsignar: { ...estadoAnterior.articuloAsignar, ['cantidad']: resultado.data.cantidadNoAsignada },
                    cantidadNoAsignada: resultado.data.cantidadNoAsignada
                }));
            } else {
                toastr.error('Vaya! Ha ocurrido un error, al obtener la cantidad no asignada, intenta nuevamente en unos segundos.');
            }
        });
    }

    setDepartamentoArea = departamentoArea => {
        this.setState(estadoAnterior => ({
            articuloAsignar: { ...estadoAnterior.articuloAsignar, ['idDepartamentoArea']: departamentoArea.id },
            departamentoAreaSelectValue: departamentoArea
        }));
    }

    setAreaTrabajo = areaTrabajo => {
        this.setState(estadoAnterior => ({
            articuloAsignar: { ...estadoAnterior.articuloAsignar, ['idAreaTrabajo']: areaTrabajo.id },
            articuloDesasignar: { ...estadoAnterior.articuloDesasignar, ['idAreaTrabajo']: areaTrabajo.id },
            areaTrabajoSelectValue: areaTrabajo
        }));
    }

    setCantidad = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            articuloAsignar: { ...estadoAnterior.articuloAsignar, ['cantidad']: value },
            articuloDesasignar: { ...estadoAnterior.articuloDesasignar, ['cantidad']: value }
        }));
    }

    setValuesDesasignacion = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            articuloDesasignar: { ...estadoAnterior.articuloDesasignar, [name]: value }
        }));
    }

    obtenerArticulos = () => {
        this.apiRest.get('/tarjetaResponsabilidadArticulosSelect/' + this.state.registro.id).then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ articulos: respuesta.data });
            } else {
                this.setState({ articulos: [] });
            }
        });
    }

    setFechaInventario = ({ target: { name, value } }) => {
        let tarjetaResponsabilidad = {
            idTarjetaResponsabilidad: this.state.registro.id,
            fecha_inventario: value
        }

        console.log('Tarjeta Responsabilida', tarjetaResponsabilidad);

        this.apiRest.post('/tarjetaResponsabilidadActualizarFechaInventario', tarjetaResponsabilidad).then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ registro: respuesta.data });
                toastr.success('Fecha de Inventario actualizada exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error, al actualizar la fecha de Inventario.');
            }
        });
    }
    
    generaPDF(datos, id){
        const auth = this.apiRest.getLS('authUser');
        if (auth !== null) {
            const headers = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                responseType: 'blob',
                body: JSON.stringify(datos ? datos : '')
            }
            fetch(process.env.REACT_APP_API_URL + "/reporteTarjetaResponsabilidadPDF/" + id, headers).then(resp => resp.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.style.display = "none";
                    a.href = url;
                    // the filename you want
                    a.download = "Tarjeta_Responsabilidad.pdf";
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
        } else {
            toastr.error('Vaya! No loggeado, por favor intenta nuevamente.');
        }
    }

    reportePDF = async () =>{
        let array = null;
        array = this.state.tabla.rows
        let id = this.state.registro.id 
        console.log(id)
        if (_valid(array)) {
            this.generaPDF(array, id)
        } else {
            toastr.error('Busque Primero la Informacion que quiere Exportar a Excel');
        }
    }

    //dowload of excel 
    Reporte = async () => {
        let array = null;
        array = this.state.tabla.rows
        let id = this.state.registro.id 
        if (_valid(array)) {
            this.generaExcel(array, id)
        } else {
            toastr.error('Debe realizar uan busqueda para exportar a Excel');
        }
    }

    generaExcel = (datos, id) =>{

        const auth = this.apiRest.getLS('authUser');
        if (auth !== null) {
            const headers = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                responseType: 'blob',
                body: JSON.stringify(datos ? datos : '')
            }
            fetch(process.env.REACT_APP_API_URL + "/nuevaTarjetaResponsabilidad/" + id, headers).then(resp => resp.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.style.display = "none";
                    a.href = url;
                    // the filename you want
                    a.download = "Tarjeta_Responsabilidad.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                });
        } else {
            toastr.error('Vaya! No loggeado, por favor intenta nuevamente.');
        }
    } 

    obtenerDepartamentosAreas() {
        this.apiRest.get('/colaboradorDepartamentoAreaAsociados').then(resultado => {
            if (resultado.exitoso) {
                if (this.apiRest.getRol()) {
                    this.setState({ departamentosAreas: resultado.data });
                    this.siHayDepartamentoArea(resultado.data);
                } else {
                    const datosTransformados = resultado.data.map(item => ({
                        ...item, id: item.value
                    }));
                    this.setState({ departamentosAreas: datosTransformados });
                    this.siHayDepartamentoArea(datosTransformados);                    
                }
            }
        });
    }

    siHayDepartamentoArea = (departamentosAreas) => {
        let departamentoArea = [];
        if (_valid(this.state.registro.id_departamento)) {
            departamentoArea = departamentosAreas.find(departamentoArea => departamentoArea.id === this.state.registro.id_departamento)
            this.setState({ departamentoAreaSelectValue: departamentoArea });
            this.setState(estadoAnterior => ({
                articuloAsignar: { ...estadoAnterior.articuloAsignar, ['idDepartamentoArea']: departamentoArea.id }
            }));
        }
    }

    obtenerDepartamentosAreasActualizar() {
        this.apiRest.get('/colaboradorDepartamentoAreaAsociados').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentosAreas: resultado.data });
                this.siHayDepartamentoAreaActualizar(resultado.data);
            }
        });
    }

    siHayDepartamentoAreaActualizar = (departamentosAreas) => {
        let departamentoArea = [];
        if (_valid(this.state.articuloAsignar.idDepartamentoArea)) {
            departamentoArea = departamentosAreas.find(departamentoArea => departamentoArea.id === this.state.articuloAsignar.idDepartamentoArea)
            this.setState({ departamentoAreaSelectValue: departamentoArea });
        }
    }

    obtenerAreasTrabajo = () => {
        this.apiRest.get('/getAreaTrabajo').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ areasTrabajo: respuesta.data });
            } else {
                this.setState({ areasTrabajo: [] });
            }
        });
    }

    render() {
        const { registro, colapsar, camposRequeridos } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Activos" breadcrumbItem="Tarjeta de Responsabilidad" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Tarjeta de Responsabilidad</h5>                                                        
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <Row>
                                                <Col lg={12}>
                                                    <p className="text-muted text-truncate mb-0">{registro.colaborador_label}</p>
                                                    {
                                                        (registro.colaborador_correo) ? (
                                                        <div>
                                                            <p className="text-muted text-truncate mb-0">{registro.colaborador_correo} --&nbsp;
                                                            <a href={"mailto:"+registro.colaborador_correo}>
                                                            Escribirle Correo</a></p>                                                            
                                                        </div>
                                                        ) : (
                                                            <p className="text-muted text-truncate mb-0">No tiene correo institucional</p>
                                                        )
                                                    }
                                                    <p></p>
                                                </Col>
                                                <Col lg={3}>
                                                    <MDBBtn className="waves-effect"color="primary" onClick={() => this.mostrarModalAsignarArticulo()}>
                                                        <MDBIcon icon="fas fa-user-plus" />{' '}
                                                        Asignar Articulo
                                                    </MDBBtn>
                                                </Col>
                                                <Col lg={3}>
                                                    <MDBBtn className="waves-effect"color="warning" onClick={() => this.enviarCorreo()}>
                                                        <MDBIcon icon="fas fa-user-plus" />{' '}
                                                        Enviar a Colaborador
                                                    </MDBBtn>
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="fecha_inventario" className="form-label">
                                                        Actualizar Fecha Inventario
                                                    </Label>
                                                    <Input
                                                        name="fecha_inventario"
                                                        value={registro.fecha_inventario}
                                                        onChange={this.setFechaInventario}
                                                        type="date"
                                                        className="form-control"
                                                    />
                                                </Col>
                                                <Col lg={3} style={{"text-align": "right"}}>
                                                    <Label htmlFor="fecha_ultimo_inventario" className="form-label">
                                                        Fecha Ultimo Inventario
                                                    </Label>
                                                    <br />
                                                    {registro.fecha_inventario_str}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={3}>
                                                    <MDBBtn className="waves-effect"color="success" onClick={() => this.Reporte()}>
                                                        <MDBIcon icon="fas fa-user-plus" />{' '}
                                                        Exportar Excel
                                                    </MDBBtn>
                                                </Col>
                                                <Col lg={3}>
                                                    <MDBBtn className="waves-effect"color="danger" onClick={() => this.reportePDF()}>
                                                        <MDBIcon icon="fas fa-user-plus" />{' '}
                                                        Imprimir PDF
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                            &nbsp;
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <Row>
                                                        <Col lg={12}>                  
                                                            <div className="table-responsive">                                          
                                                                <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </div>

                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect"color="danger" onClick={() => { this.props.history.replace('/tarjetaResponsabilidadListado') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect"color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Listo
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* MODAL */}
                <Modal isOpen={this.state.modalAsignarArticulo} size="lg">
                    <ModalHeader>
                        Asignar Articulo
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col lg={12}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="articuloSelectValue" className="form-label">
                                        Articulo
                                    </Label>
                                    <Select
                                        name="articuloSelectValue"
                                        options={this.state.articulos}
                                        onChange={this.setArticulo}>
                                    </Select>
                                    <div className={this.state.errors.articuloRequerido ? 'error' : 'hidden'}>Requerido</div>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="solicitar_a" className="form-label">
                                        Departamento / Area
                                    </Label>
                                    <Select
                                        name="departamentoAreaSelectValue"
                                        options={this.state.departamentosAreas}
                                        value={this.state.departamentoAreaSelectValue}
                                        onChange={this.setDepartamentoArea}
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="areaTrabajoSelectValue" className="form-label">
                                        Ubicaci&oacute;n Area Trabajo
                                    </Label>
                                    <Select
                                        name="areaTrabajoSelectValue"
                                        value={this.state.areaTrabajoSelectValue}
                                        options={this.state.areasTrabajo}
                                        onChange={this.setAreaTrabajo}>
                                    </Select>
                                    <div className={this.state.errors.areaTrabajoRequerido ? 'error' : 'hidden'}>Requerido</div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="cantidad" className="form-label">
                                        Cantidad no Asignada:
                                    </Label>
                                    <Input
                                        name="cantidadNoAsignada"
                                        value={this.state.cantidadNoAsignada}
                                        type="number"
                                        className="form-control"
                                        disabled="disabled"
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="cantidad" className="form-label">
                                        Cantidad para Asignar:
                                    </Label>
                                    <Input
                                        name="cantidad"
                                        value={this.state.articuloAsignar.cantidad}
                                        onChange={this.setCantidad}
                                        min="0"
                                        max={this.state.cantidadNoAsignada}
                                        type="number"
                                        className="form-control"
                                        placeholder="Ingresa la cantidad"
                                    />
                                    <div className={this.state.errors.areaTrabajoRequerido ? 'error' : 'hidden'}>Requerido</div>
                                    <div className={this.state.errors.areaTrabajoMayor ? 'error' : 'hidden'}>No puede ser mayor a la cantidad no asignada.</div>
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect"color="success" onClick={() => this.asignarArticulo()}>
                            <MDBIcon icon="fas fa-user-check" /> {' '}
                            Asignar
                        </MDBBtn>
                        <MDBBtn className="waves-effect"color="warning" onClick={() => this.ocultarModalAsignarArticulo()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>

                {/* MODAL */}
                <Modal isOpen={this.state.modalActualizarArticulo} size="mm">
                    <ModalHeader>
                        Actualizar Articulo
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col lg={12}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="solicitar_a" className="form-label">
                                        Departamento / Area
                                    </Label>
                                    <Select
                                        name="departamentoAreaSelectValue"
                                        options={this.state.departamentosAreas}
                                        value={this.state.departamentoAreaSelectValue}
                                        onChange={this.setDepartamentoArea}
                                        validate={{ required: { value: true } }}
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="areaTrabajoSelectValue" className="form-label">
                                        Ubicaci&oacute;n Area Trabajo
                                    </Label>
                                    <Select
                                        name="areaTrabajoSelectValue"
                                        value={this.state.areaTrabajoSelectValue}
                                        options={this.state.areasTrabajo}
                                        onChange={this.setAreaTrabajo}>                                        
                                    </Select>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="cantidad" className="form-label">
                                        Cantidad:
                                    </Label>
                                    <Input
                                        name="cantidad"
                                        value={this.state.articuloAsignar.cantidad}
                                        onChange={this.setCantidad}
                                        min="0"
                                        type="number"
                                        className="form-control"
                                        placeholder="Ingresa la cantidad"
                                    />
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect"color="success" onClick={() => this.actualizarArticulo()}>
                            <MDBIcon icon="fas fa-user-check" /> {' '}
                            Actualizar
                        </MDBBtn>
                        <MDBBtn className="waves-effect"color="warning" onClick={() => this.ocultarModalActualizarArticulo()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>

                {/* MODAL */}
                <Modal isOpen={this.state.modalDesasignarArticulo} size="mm">
                    <ModalHeader>
                        Desasignar Articulo {this.state.articuloSelectValue ? this.state.articuloSelectValue.nombre : ""}
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="razon_desasignado" className="form-label">
                                        Raz&oacute;n
                                    </Label>
                                    <select
                                        name="razon_desasignado"
                                        onChange={this.setValuesDesasignacion}
                                        className="form-control">
                                        <option value="">Seleccionar</option>
                                        <option value="1">Traslado</option>
                                        <option value="2">Venta</option>
                                        <option value="3">Inventario</option>
                                        <option value="4">Otro</option>
                                    </select>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="cantidad_desasignado" className="form-label">
                                        Cantidad:
                                    </Label>
                                    <Input
                                        name="cantidad"
                                        value={this.state.articuloDesasignar.cantidad}
                                        onChange={this.setValuesDesasignacion}
                                        min="0"
                                        type="number"
                                        className="form-control"
                                        placeholder="Ingresa la cantidad"
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="motivo_desasignado" className="form-label">
                                        Motivo
                                    </Label>
                                    <Input
                                        name="motivo_desasignado"
                                        onChange={this.setValuesDesasignacion}
                                        type="text"
                                        maxLength="250"
                                        className="form-control"
                                        placeholder="Ingresa el motivo"/>
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect"color="danger" onClick={() => this.desasignarArticulo()}>
                            <MDBIcon icon="fas fa-trash" /> {' '}
                            Desasignar
                        </MDBBtn>
                        <MDBBtn className="waves-effect"color="warning" onClick={() => this.ocultarModalDesasignarArticulo()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        );
    }
}